// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".desktop-logo[data-v-34550d99]{height:70%;cursor:pointer}.mobile-logo[data-v-34550d99]{height:65%;cursor:pointer}.unvergessen-search-field[data-v-34550d99]{margin-right:15px}", ""]);
// Exports
module.exports = exports;
